import { formatCurrency, formatCurrencyCompact, formatPercent } from '@/utils/format-currency'
import { MASKED_DEAL_VALUE } from '@/utils/dealDisplay'

export { MASKED_DEAL_VALUE as MASKED_CRM_VALUE }

export function formatDashboardCurrency(
  value: number,
  visible: boolean,
  compact = false,
): string {
  if (!visible) return MASKED_DEAL_VALUE
  return compact ? formatCurrencyCompact(value) : formatCurrency(value)
}

export function formatDashboardPercent(value: number, visible: boolean, decimals = 1): string {
  if (!visible) return MASKED_DEAL_VALUE
  return formatPercent(value, decimals)
}

export function formatDashboardNumber(value: number | string, visible: boolean): string {
  if (!visible) return MASKED_DEAL_VALUE
  return String(value)
}

export function formatFunnelStageValue(value: number, visible: boolean): string {
  if (!visible) return MASKED_DEAL_VALUE
  return value >= 10_000 ? formatCurrencyCompact(value) : formatCurrency(value)
}
